import MCurrentUserStatus from './index.vue';

MCurrentUserStatus.install = app => {
  app.component(MCurrentUserStatus.name, MCurrentUserStatus);
};

export default MCurrentUserStatus;
